import { useFormContext } from 'react-hook-form';
import { FormField } from '@fashionnovateam/nova-ui-toolkit';
import { AddTagFormData, ItemFilters } from '../types';
import { ControlledFormInput } from '../../../../Lib/Utils/FormUtils/ControlledFormInput';
import { FiberContentDataGrid } from '../components/FiberContentDataGrid';

export function SelfShellSection() {
  const { control, watch } = useFormContext<AddTagFormData>();
  const sampleType = watch('sampleType');

  const isRequired = sampleType !== ItemFilters.FIRST_SAMPLE;

  return (
    <div className="rounded-xl border border-neutral-200 shadow-sm p-5 space-y-4">
      <h3 className="text-lg font-medium text-gray-900">Self (Shell)</h3>

      <p className="mt-4 mb-4 border-b nu-border-neutral-200" />
      <FormField label="Self (Shell) Content" required>
        <p className="text-sm mb-3 text-base-disabled">
          Total of all contents must equal 100%.
        </p>

        <FiberContentDataGrid />
      </FormField>

      <ControlledFormInput
        name="fabricWeight"
        label="Self (Shell) Fabric Weight"
        control={control}
        inputType="number"
        required={isRequired}
        rules={
          isRequired
            ? {
                required: 'Fabric weight is required',
              }
            : undefined
        }
        inputProps={{
          className: 'w-full',
          placeholder: '0',
          min: '0',
          endAdornment: <span className="text-gray-500 text-sm">gsm</span>,
        }}
      />

      <ControlledFormInput
        name="fabricCodeName"
        label="Self (Shell) Fabric Code & Name"
        control={control}
        inputType="text"
        required={isRequired}
        rules={
          isRequired
            ? {
                required: 'Fabric code & name is required',
              }
            : undefined
        }
        inputProps={{
          className: 'w-full',
          placeholder: 'Enter fabric code and name',
        }}
      />
    </div>
  );
}
